import React from 'react';
import HeaderTabButton from './HeaderTabButton';

const DEFAULT_TABS = [
  { key: 'submitted', label: 'Submitted' },
  { key: 'accepted', label: 'Accepted' },
  { key: 'needPrep', label: 'Need Prep' },
  { key: 'saved', label: 'Saved Jobs' },
];

const DEFAULT_MOBILE_TABS = [
  { key: 'applied', label: 'Applied' },
  { key: 'saved', label: 'Saved Jobs' },
];

const HeaderTab = ({
  counts,
  selectedTab,
  onChangeTab,
  $isMobile,
  tabs = DEFAULT_TABS,
  mobileTabs = DEFAULT_MOBILE_TABS,
}) => {
  const visibleTabs = $isMobile ? mobileTabs : tabs;

  return (
    <div className='flex w-full items-center pb-6'>
      <div className='flex p-1 tabletH:p-1.5 bg-grayscale-gray02/50 rounded-[20px] tabletH:rounded-[15px] w-full'>
        {visibleTabs.map((tab) => (
          <HeaderTabButton
            key={tab.key}
            label={tab.label}
            count={counts[tab.key]}
            selected={selectedTab === tab.key}
            onClick={() => onChangeTab(tab.key)}
            $isMobile={$isMobile}
          />
        ))}
      </div>
    </div>
  );
};

export default HeaderTab;
